<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            Bank Account Types
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>
            </div>
          </div>

          <div class="nav-tree">
            <el-button @click="openModalAdd" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">Add Bank Account Type</el-button>
          </div>

          <el-table
              max-height="720"
              size="mini"
              :data="tableData"
              :empty-text="$t('general_noData')"
              style="width: 100%">
            <el-table-column
                label="ID"
                type="index"
                width="50">
            </el-table-column>
            <el-table-column
                prop="code"
                width="150"
                :label="$t('settings_accountThink_paymentMethods_code')">
            </el-table-column>
            <el-table-column
                prop="name"
                :label="$t('settings_accountThink_paymentMethods_name')">
            </el-table-column>
            <el-table-column
                prop="createdDate"
                :label="$t('settings_accountThink_paymentMethods_createDate')"
                width="150">
              <template slot-scope="scope">
                {{moment(scope.row.createdDate).format('D MMM YY')}}
              </template>
            </el-table-column>
            <el-table-column
                width="120"
                :label="$t('settings_accountThink_paymentMethods_operations')">
              <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="primary"
                    plain
                    icon="el-icon-edit"
                    @click="handleEdit(scope.$index, scope.row)"></el-button>
                <el-button
                    size="mini"
                    type="danger"
                    plain
                    icon="el-icon-delete"
                    @click="handleDelete(scope.$index, scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>

        </div>
      </div>
    </div>

    <!-- add -->
    <sweet-modal blocking title="Add Bank Account Type" ref="addBankAccountType" class="modal" v-on:close="closeModal">
      <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
        <el-form-item prop="name">
          <el-input :label="$t('settings_accountThink_paymentMethods_name')" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input :label="$t('settings_accountThink_paymentMethods_code')" v-model="form.code"></el-input>
        </el-form-item>
        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('addBankAccountType')">{{$t('general_cancel')}}</el-button>
          <el-button @click="create('form')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>


    <!-- edit -->
    <sweet-modal blocking title="Edit Bank Account Type" ref="editBankAccountType" class="modal" v-on:close="closeModal">
      <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
        <el-form-item prop="name">
          <el-input :label="$t('settings_accountThink_paymentMethods_name')" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input :label="$t('settings_accountThink_paymentMethods_code')" v-model="form.code"></el-input>
        </el-form-item>
        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('editBankAccountType')">{{$t('general_cancel')}}</el-button>
          <el-button @click="update('form')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>

  </div>
</template>

<script>
let moment = require('moment')
import axios from 'axios'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

export default {
  name: "BankAccountTypes",
  components: {
    SweetModal,
  },
  data(){
    return {
      tableData: [],
      form: {
        name: null,
        code: null
      },
      activeItemId: null,
      rules: {
        name: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        code: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ]
      },
      moment: moment
    }
  },
  mounted() {
    this.loadList()
  },
  methods: {
    loadList() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(`/api/v1/bankAccountType/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.tableData = response.data.list
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
    },
    create(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`/api/v1/bankAccountType/create?companyId=${this.$route.query.companyId}`, {
                code: this.form.code,
                name: this.form.name
              })
              .then(response => {
                this.$refs.addBankAccountType.close()
                this.loadList()
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
        }else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    update(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`/api/v1/bankAccountType/update?id=${this.activeItemId}`, {
                code: this.form.code,
                name: this.form.name
              })
              .then(response => {
                this.$refs.editBankAccountType.close()
                this.loadList()
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
        }else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    closeModal() {
      this.form.name = null
      this.form.code = null
      this.$refs['form'].resetFields();
    },
    modalCancel(ref) {
      this.activeItemId = null
      this.$refs[ref].close();
    },
    handleEdit(index, row) {
      this.activeItemId = row.id
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(`/api/v1/bankAccountType/item?id=${row.id}`)
          .then(response => {
            this.$refs.editBankAccountType.open()
            this.form.name = response.data.item.name
            this.form.code = response.data.item.code
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
    },
    handleDelete(index, row) {
      this.$confirm('This will permanently delete Bank Account Type. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'info'
      }).then(() => {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/bankAccountType/delete?id=${row.id}`)
            .then(response => {
              this.loadList()
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
    routerLink(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    },
    openModalAdd(){
      this.$refs.addBankAccountType.open()
    }
  }
}
</script>

<style lang="less" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
